<div class="text-center">
    <h1>No Programme Assigned</h1>
    <div>
        <p>You have not been assigned to a programme.  Please contact your healthcare professional for further assistance.</p>
    </div>